import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["nps"],
                headline:
                    "How likely is it that you would recommend this company to a friend or colleague?",
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline:
                    "What changes would this company have to make for you to give it a higher rating?",
                longAnswer: true,
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What is your gender?",
                choices: [
                    generateNewChoice("Female"),
                    generateNewChoice("Male"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What is your age?",
                choices: [
                    generateNewChoice("18 to 24"),
                    generateNewChoice("25 to 34"),
                    generateNewChoice("35 to 44"),
                    generateNewChoice("45 to 54"),
                    generateNewChoice("55 to 64"),
                    generateNewChoice("65 to 74"),
                    generateNewChoice("75 or older"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What is your approximate average household income?",
                choices: [
                    generateNewChoice("$0-$24,999"),
                    generateNewChoice("$25,000-$49,999"),
                    generateNewChoice("$50,000-$74,999"),
                    generateNewChoice("$75,000-$99,999"),
                    generateNewChoice("$100,000-$124,999"),
                    generateNewChoice("$125,000-$149,999"),
                    generateNewChoice("$150,000-$174,999"),
                    generateNewChoice("$175,000-$199,999"),
                    generateNewChoice("$200,000 and up"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "In what country do you currently reside?",
                placeholder: "",
                longAnswer: false,
            },
        ],
    },
];
export const netPromoterScoreSurveyTemplate = generateSurveyTemplate({
    name: "Net Promoter® Score (NPS) survey",
    pages,
});
